import Footer from './Footer';
import Player from './Player';
import Spectator from './Spectator';

export default { Footer, Player, Spectator };
